/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.6.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Location = /** @class */ (function () {
    function Location() {
    }
    return Location;
}());
export { Location };
//# sourceMappingURL=Location.js.map